import React, {useState} from 'react';
import {pdfjs, Document, Page} from 'react-pdf';
import {isEmpty, get} from 'lodash';
import api from 'api';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type PDFPreviewTypes = {
  reservationId?: string;
  housingId?: string;
};

function PDFPreview({reservationId, housingId}: PDFPreviewTypes) {
  const [contract, setContract] = useState<any>(null);

  React.useEffect(() => {
    if (!housingId) {
      return;
    }
    api.documents.getContracts(`housing_sample_id=${housingId}`).then(data => {
      const contractData = get(data.data, '0.file');
      setContract(contractData);
    });
  }, [housingId, contract]);

  if (isEmpty(contract)) {
    return null;
  }

  return (
    <Document file={contract}>
      <Page pageNumber={1} height={485} />
    </Document>
  );
}

export default PDFPreview;
